import React from 'react';
import { colors } from 'seedling/constants';
import PropTypes from 'prop-types';

const PlusIcon = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width}
    height={props.height}
    viewBox={`0 0 20 20`}
  >
    <path
      fill={props.color}
      d="M9 9H4c-.552 0-1 .448-1 1s.448 1 1 1h5v5c0 .552.448 1 1 1s1-.448 1-1v-5h5c.552 0 1-.448 1-1s-.448-1-1-1h-5V4c0-.552-.448-1-1-1s-1 .448-1 1v5z"
    />
  </svg>
);

PlusIcon.displayName = 'PlusIcon';

PlusIcon.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
};

PlusIcon.defaultProps = {
  width: 20,
  height: 20,
  color: colors.mediumGreenhouseGreen,
};

export default PlusIcon;
